/**
 * @description 告警查询 alarmQuery
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'
import ExportTable from '@/utils/exportTable'

const alarmQueryBiz = new Logic()

alarmQueryBiz.info = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmQuery.info,
    data: data
  })
}

alarmQueryBiz.query = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmQuery.query,
    data: data
  })
}

alarmQueryBiz.queryHistory = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmQuery.queryHistory,
    data: data
  })
}

alarmQueryBiz.handle = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmQuery.handle,
    data: data
  })
}

alarmQueryBiz.componmentQuery = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmQuery.componmentQuery,
    data: data
  })
}

alarmQueryBiz.top5 = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmQuery.top5,
    data: data
  })
}

alarmQueryBiz.singleHandle = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmQuery.singleHandle,
    data: data
  })
}

alarmQueryBiz.getAlarmLevelTrend = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmQuery.getAlarmLevelTrend,
    data: data
  })
}

/**
 * Created by libaiqi on 2018/11/19.
 * 导出
 * @param fields 表头信息{name: text,...}
 * @param time  时间需要转换的表头
 * @param staticDictionary 静态字典
 */
alarmQueryBiz.exportCurrentAlarm = function (fields, search, time, staticDictionary, success, fail) {
  const exportTable = new ExportTable({
    requestData: this.REQUEST_OPT.alarmQuery.query,
    fields: fields,
    search: search,
    time: time,
    staticDictionary: staticDictionary
  })

  exportTable.send(success, fail)
}

alarmQueryBiz.exportHistoryAlarm = function (fields, search, time, staticDictionary, success, fail) {
  const exportTable = new ExportTable({
    requestData: this.REQUEST_OPT.alarmQuery.queryHistory,
    fields: fields,
    search: search,
    time: time,
    staticDictionary: staticDictionary
  })

  exportTable.send(success, fail)
}

export default alarmQueryBiz
